import * as React from 'react';

import { translate } from '~l10n/client';
import { AiAssistedBadgeLink } from '~teacher/components/QuizEditor/AiAssistedBadgeLink';

export function ExtractQuestionsHeader() {
  return (
    <div className="flex gap-4">
      <div className="flex flex-shrink flex-col">
        <div className="flex">
          <AiAssistedBadgeLink />
        </div>
        <div className="font-display text-md leading-normal text-blue-900 font-700">
          {translate('Extract Questions from Document')}
        </div>
        <div className="text-sans text-base leading-normal text-blue-600">
          {translate(
            "Upload a file, and we'll find and extract the questions in it."
          )}
        </div>
      </div>
    </div>
  );
}
